<template>
  <a-card :bordered="false" style="height: 100%; padding-bottom: 200px">
    <div class="table-page-search-wrapper">
      <a-form-model ref="form" :model="model" layout="inline">
        <!--  通过部门选择用户控件 -->
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-model-item label="选择总结" prop="summaryId">
              <j-dict-select-tag
                v-model="model.summaryId"
                placeholder="选择总结"
                dictCode="okr_group,name,id"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="选择用户" prop="userIds">
              <j-select-user-by-dep v-model="model.userIds" :multi="true" store="id"></j-select-user-by-dep>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="选择汇报对象" prop="reporterIds">
              <j-select-user-by-dep v-model="model.reporterIds" :multi="true"></j-select-user-by-dep>
            </a-form-model-item>
          </a-col>

          <a-col :span="6">
            <a-button @click="handleQuery" type="primary" icon="plus">查询</a-button>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
    <all-plan-list ref="list" />
    <!-- <a-row :gutter="24">
      <a-col :span="12">
        <a-tabs defaultActiveKey="1">
          <a-tab-pane tab="工作计划" key="1">
            <all-plan-list ref="list" />
          </a-tab-pane>
        </a-tabs>
      </a-col>
      <a-col :span="12">
        <a-tabs defaultActiveKey="1">
          <a-tab-pane tab="工作计划-修订" key="1">
            <all-plan-revise-list ref="listRevise" />
          </a-tab-pane> </a-tabs
      ></a-col>
    </a-row> -->
  </a-card>
</template>

<script>
import Vue from 'vue'
import AllPlanList from './modules/AllPlanList.vue'
import AllPlanReviseList from './modules/AllPlanReviseList.vue'

export default Vue.extend({
  name: 'ShowAllPlan',
  components: { AllPlanList, AllPlanReviseList },
  data() {
    return {
      model: {},
      // 表头
    }
  },
  methods: {
    handleQuery() {
      this.$refs.list.handleQuery(this.model)
      this.$refs.listRevise.handleQuery(this.model)
    },
  },
})
</script>
<style lang="less" scoped>
.ant-card-body .table-operator {
  margin-bottom: 18px;
}

.ant-table-tbody .ant-table-row td {
  padding-top: 15px;
  padding-bottom: 15px;
}

.anty-row-operator button {
  margin: 0 5px;
}

.ant-btn-danger {
  background-color: #ffffff;
}

.ant-modal-cust-warp {
  height: 100%;
}

.ant-modal-cust-warp .ant-modal-body {
  height: calc(100% - 110px) !important;
  overflow-y: auto;
}

.ant-modal-cust-warp .ant-modal-content {
  height: 90% !important;
  overflow-y: hidden;
}
</style>